import { render, staticRenderFns } from "./FabricatedTab.vue?vue&type=template&id=c2a89094&lang=pug&"
import script from "./FabricatedTab.vue?vue&type=script&lang=js&"
export * from "./FabricatedTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports